export enum KEY_LOCAL_STORAGE {
  TOKEN = 'token',
  FILTERS = 'filters'
}
